











































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CtaButton from "../ctaButton/ctaButton.vue";
import HomeCarouselFrame from "./HomeCarouselFrame.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

interface HomeServiceSlide {
  image: string;
  title: string;
  subtitle: string;
  description: string;
  price?: string;
  ctaText: string;
  ctaUrl: string;
  ctaHref?: string;
}

@Component({
  components: { CtaButton, HomeCarouselFrame, VueSlickCarousel },
})
export default class HomeServicesCarousel extends Vue {
  @Prop({ type: Array, default: () => [] }) slides!: HomeServiceSlide[];

  activeIndex = 0;
  touchStartX: number | null = null;

  get activeSlide() {
    return this.getSlideAt(this.activeIndex, 0);
  }

  get shouldAutoplay() {
    return this.slides.length > 2;
  }

  get visibleRadius() {
    if (this.slides.length > 4) return 2;
    if (this.slides.length > 2) return 1;
    return 0;
  }

  get isDouble() {
    return false;
  }

  get visibleOffsets() {
    const total = this.slides.length;
    if (total <= 1) return [0];
    const offsets = [0];
    for (let step = 1; step <= 3; step++) {
      if (offsets.length < total) offsets.push(step);
      if (offsets.length < total) offsets.unshift(-step);
    }
    return offsets;
  }

  get visibleSlides() {
    const total = this.slides.length;
    if (total === 0) return [];
    return this.visibleOffsets.map((offset) => {
      const index = (this.activeIndex + offset + total) % total;
      const slide = this.slides[index] || this.slides[0];
      const ariaLabel = slide.title
        ? slide.title
        : String(this.$t("Services"));
      return {
        offset,
        index,
        slide,
        key: String(index),
        ariaLabel,
      };
    });
  }

  getSlideAt(index: number, offset: number) {
    const total = this.slides.length;
    if (total === 0) {
      return {
        image: "",
        title: "",
        subtitle: "",
        description: "",
        price: "",
        ctaText: "",
        ctaUrl: "",
        ctaHref: "",
      };
    }
    const nextIndex = (index + offset + total) % total;
    return this.slides[nextIndex] || this.slides[0];
  }

  get carouselSettings() {
    const shouldLoop = this.slides.length > 1;
    const shouldAutoplay = this.shouldAutoplay;
    return {
      arrows: false,
      dots: false,
      infinite: shouldLoop,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: shouldAutoplay,
      speed: 0,
      autoplaySpeed: 5000,
      cssEase: "ease-in-out",
      pauseOnHover: false,
      pauseOnFocus: false,
    };
  }

  onAfterChange(current: any) {
    if (typeof current === "number") {
      this.activeIndex = current;
      return;
    }
    if (current && typeof current.currentSlide === "number") {
      this.activeIndex = current.currentSlide;
    }
  }

  setActiveIndex(index: number) {
    if (this.slides.length === 0) return;
    const total = this.slides.length;
    const nextIndex = ((index % total) + total) % total;
    this.activeIndex = nextIndex;
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.goTo) {
      carousel.goTo(nextIndex);
    }
    this.restartAutoplay();
  }

  setActiveOffset(offset: number) {
    if (this.slides.length === 0) return;
    const total = this.slides.length;
    const nextIndex = (this.activeIndex + offset + total) % total;
    this.setActiveIndex(nextIndex);
  }

  circleClass(offset: number) {
    const position = this.positionClass(Math.max(-2, Math.min(2, offset)));
    if (Math.abs(offset) <= this.visibleRadius) return [position];
    return [position, "homeServices__circle--staging"];
  }

  positionClass(offset: number) {
    if (offset === 0) return "homeServices__circle--center";
    if (offset === -1) return "homeServices__circle--left";
    if (offset === 1) return "homeServices__circle--right";
    if (offset === -2) return "homeServices__circle--leftSm";
    if (offset === 2) return "homeServices__circle--rightSm";
    return "homeServices__circle--center";
  }

  onCircleClick(offset: number) {
    if (offset === 0) return;
    this.setActiveOffset(offset);
  }

  nextSlide() {
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.next) {
      carousel.next();
    }
    this.restartAutoplay();
  }

  prevSlide() {
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.prev) {
      carousel.prev();
    }
    this.restartAutoplay();
  }

  onTouchStart(e: TouchEvent) {
    this.touchStartX = e.touches[0].clientX;
  }

  onTouchEnd(e: TouchEvent) {
    if (this.touchStartX === null) return;
    const deltaX = e.changedTouches[0].clientX - this.touchStartX;
    this.touchStartX = null;
    if (Math.abs(deltaX) < 40) return;
    if (deltaX < 0) this.nextSlide();
    else this.prevSlide();
  }

  restartAutoplay() {
    if (!this.shouldAutoplay) return;
    const carousel = this.$refs.carousel as any;
    if (!carousel) return;
    if (carousel.pause) {
      carousel.pause();
    } else if (carousel.slickPause) {
      carousel.slickPause();
    }
    if (carousel.play) {
      carousel.play();
      return;
    }
    if (carousel.slickPlay) {
      carousel.slickPlay();
    }
  }
}
